import {Component, OnInit, OnDestroy} from '@angular/core';
import {User} from '../../../../../models/user';
import {BusinessDataService} from '../../../../../data-repositories/business-data.service';
import {StagesNavigationService} from '../../../stages-navigation/stages-navigation.service';
import {ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-employment-second-holder',
  templateUrl: './employment-second-holder.component.html',
  styleUrls: ['./employment-second-holder.component.scss']
})
export class EmploymentSecondHolderComponent implements OnInit, OnDestroy {
  user: User;
  private subscription = new Subscription();

  constructor(
    private service: BusinessDataService,
    public navigationService: StagesNavigationService) {

    this.subscription.add(this.service.GetUser().subscribe(s => {
      this.user = s.model;
    }));
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public updateUser(): void {
    this.service.updateUserWithoutValidation(this.user, () => {
    });
  }

  isEmployed(): boolean {
    return this.user.secondHolder.employmentModel &&
      (this.user.secondHolder.employmentModel.employmentStatus === 'EMPLOYED' ||
        this.user.secondHolder.employmentModel.employmentStatus === 'SELFEMPLOYED');
  }
}
